import React from 'react'


import {MDBBox, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import './CheckUsername.scss'
import cogoToast from 'cogo-toast';
import {connect} from "react-redux";
import {setLoginStep, userLogin} from "../../Actions";
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import TermsAndConditionContent from "../../component/TermsAndConditionContent/TermsAndConditionContent";
import {Slide, Zoom, Fade} from "react-reveal";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import CheckUserNameQuery from "../../queries/CheckUserNameQuery";
import {assetUrl} from "../../serviceApi";


const check = assetUrl+'images/username_check.svg'
const whiteArrow = assetUrl+'images/white-arrow-right.png'
const cone = assetUrl+'images/username_cone.svg'
const ball = assetUrl+'images/usernmae_ball.svg'
const verify = assetUrl+'images/username_verified.svg'
const not_verify = assetUrl+'images/username_not_verify.svg'

class CheckUsername extends React.Component {
	state = {
		// mobileno:"",
		username: "",
		usernameSuggestion: [],
		loading: false,
		available: false,
		open_modal: false,
		trigger: false,
		validated: false,
		time: {},
		seconds: 5
	}

	componentDidMount() {
		this.setState({
				trigger: true
			}
			, () => {
			});
	}

	getUserNameSuggestion = (e) => {
		let variables = {
			username: this.state.username === e.target.value ? this.state.username : e.target.value,
			mobileNumber: "+91" + this.props.user_details.mobileNumber
		}
		fetchQuery(environment, CheckUserNameQuery, variables)
			.toPromise()
			.then(response => {
				if (response.checkUsername !== null && response.checkUsername.length > 1) {

					this.setState({
						loading: false,
						available: false,
						usernameSuggestion: response.checkUsername,
					})
					// console.log(this.state.usernameSuggestion)
				} else {
					this.setState({
						loading: false,
						usernameSuggestion: [],
						available: true
					})
				}
			}, err => {
				console.log(err);
				this.setState({
					loading: false,
					usernameSuggestion: [],
					available: true
				})
				// console.log(this.state.response.checkUsername);
			});
	}

	handleInpuChange = (e) => {
		this.setState({
			username: e.target.value
		})
		let data = {
			'username': e.target.value,
		}
		let scope = this;
		this.setState({
			loading: true
		})
		this.getUserNameSuggestion(e)
	}

	onUsernameSelect = (username) => {
		this.setState({...this.state, username: username})
		let variables = {
			username: username,
			mobileNumber: "+91" + this.props.user_details.mobileNumber
		}
		fetchQuery(environment, CheckUserNameQuery, variables)
			.toPromise()
			.then(response => {
				if (response.checkUsername !== null && response.checkUsername.length > 1) {
					this.setState({
						loading: false,
						available: false,
						usernameSuggestion: response.checkUsername,
					})

				} else {
					this.setState({
						loading: false,
						usernameSuggestion: [],
						available: true
					})
				}
			}, err => {
				console.log(err);
				this.setState({
					loading: false,
					usernameSuggestion: [],
					available: true
				})

			});

	}

	rippleEffect = (e) => {
		if (this.state.validated === false) {

			let x = e.clientX;
			let y = e.clientY;
			let buttonTop = e.target.offsetTop;
			let buttonLeft = e.target.offsetLeft;
			let xInside = x - buttonLeft;
			let yInside = y - buttonTop;

			let circle = document.createElement('span');
			circle.classList.add('user-circle');
			// circle.style.top = yInside + 'px';
			circle.style.left = xInside + 'px';
			if (document.querySelector("#submitButton-username")) {

				document.querySelector("#submitButton-username").appendChild(circle);

				setTimeout(() => {

					circle.remove();

				}, 100);

			}
		}
	}

	// new
	handleSubmit = (e) => {
		this.rippleEffect(e)
		if (this.state.username === "") {
			cogoToast.warn("Please Enter your Username", {position: 'top-center'});
		} else {
			this.setState({
				loading: true
			})
			let variables = {
				username: this.state.username,
				mobileNumber: "+91" + this.props.user_details.mobileNumber
			}
			fetchQuery(environment, CheckUserNameQuery, variables)
				.toPromise()
				.then(response => {
					if (response.checkUsername !== null && response.checkUsername.length === 1) {
						this.setUserData()
						cogoToast.success("Successfully created Username ", {position: 'top-center'});
					} else {
						this.setState({
							loading: false,
						})
						// cogoToast.success("Successfully created Username ", {position: 'top-center'});
					}
				}, err => {
					console.log(err);
					this.setState({
						loading: false,
					})
					cogoToast.warn("Username already Exist", {position: 'top-center'});
				});
		}
	}

	setUserData = () => {
		let data = {
			user_details: {
				username: this.state.username,
				mobileNumber: this.props.user_details.mobileNumber,
				token: "",
				welcomeBonus: 0,
				refreshToken: "",
				user: {}
			},
			logged_in: false,
		}
		this.props.addUserData(data);
		// this.props.initCircleRotation()
		setTimeout(() => {
			this.setState({...this.state, trigger: false})
		}, 1000)

		setTimeout(() => {
			this.props.setLoginStep(3);
			this.props.handleLoginSteps(3);
		}, 1000)
	}

	toggleModal = () => {
		this.setState({
			open_modal: !this.state.open_modal
		});
	}

	goToPreviousPage = () => {
		this.props.handleLoginSteps(1);
		this.props.setLoginStep(1);
	}
	goToInitialPage = () => {
		this.props.handleLoginSteps(0);
		this.props.setLoginStep(0);
	}

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {

		const styleMNE = "user-"
		return (

			<div className="username-login-component d-flex flex-column justify-content-between px-3 pt-4 pb-3">
				<MDBBox>
					<LoginHeader
						handleBackClick={this.goToInitialPage}
						handleCloseClick={() => this.props.history.push("/")}
					/>
					<div>
						{/*<Slide right cascade opposite when={this.state.trigger}>*/}
							<div className={styleMNE + 'imageWrapper'}>
								<div className={styleMNE + 'elipse-section'}>

									<div className={styleMNE + 'cone'}>
										<Zoom>
											<img src={cone} alt={"altImage"}/>
										</Zoom></div>
									<div className={styleMNE + 'ball'}>
										<Zoom>
											<img src={ball} alt={"altImage"}/>
										</Zoom>
									</div>

									<Fade delay={500} distance={"1000px"} right>{
										this.state.available ?
											<div className={styleMNE + 'verified'}><img src={verify} alt={"altImage"}/>
											</div> :
											<div className={styleMNE + 'verified'}><img src={not_verify}
											                                            alt={"altImage"}/></div>
									}</Fade>

								</div>
							</div>
						{/*</Slide>*/}

						<div className={"form-section"}>
							{/*<Slide right cascade opposite when={this.state.trigger}>*/}
								<div>
									<p className={styleMNE + 'heading my-2'}>
										Choose a Username
									</p>
									<p className={styleMNE + "subText mt-2 mb-1"}>
										This will be your Public Handle
									</p>
									<div style={{position: "relative"}}>
										<input type="text"

										       className={styleMNE + 'inputElement mt-2 mb-0'}
										       value={this.state.username}
										       onKeyDown={(e) => {
											       if (e.key === 'Enter') {
												       this.handleSubmit(e);
											       }
										       }}
										       onChange={(e) => this.handleInpuChange(e)}
										       onInput={(e) => this.handleInpuChange(e)}
										/>
										{
											this.state.available &&
											<img src={check} alt={"alt"} className={"username-check"}/>
										}
										{
											this.state.usernameSuggestion.length > 1 &&
											<div className={'username-suggest-box p-3'}>
												<p className={"username-suggest-title"}>Username Suggestion</p>
												{(this.state.usernameSuggestion).slice(0, 3).map(item => {
													return <p className={"username-suggest"}
													          onClick={() => this.onUsernameSelect(item.username)}>
														{item.username}</p>

												})}
											</div>
										}

									</div>

								</div>

							{/*</Slide>*/}
							{
								this.state.available &&
								<p className={styleMNE + "greenText mt-2 mb-1"}>
									Username Available!
								</p>}
						</div>

					</div>

				</MDBBox>

				<div className={styleMNE + 'buttonWrapper text-center mx-auto '}>
					<button
						className={styleMNE + "button btn  d-flex align-items-center justify-content-center my-1"}
						onClick={(e) => this.handleSubmit(e)}
						id={"submitButton-mobile"}
						disabled={this.state.loading && this.state.available === false && !(this.state.usernameSuggestion.length > 0)}
					>
						<p className={"my-0 mx-2"}> Confirm Username</p>
						<img src={whiteArrow} alt={'alt'} className={styleMNE + "icon"}/>
					</button>
				</div>

				<MDBModal isOpen={this.state.open_modal} toggle={this.toggleModal}>
					<MDBModalHeader toggle={this.toggleModal}>Terms & Conditions</MDBModalHeader>
					<MDBModalBody>
						<TermsAndConditionContent/>
					</MDBModalBody>
				</MDBModal>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details
})

const mapDispatchToProps = dispatch => ({
	addUserData: data => dispatch(userLogin(data)),
	setLoginStep: data => dispatch(setLoginStep(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckUsername);

